import { createFileRoute } from "@tanstack/react-router";
import { GettingStartedPage } from "@/features/getting-started/GettingStartedPage";

export const Route = createFileRoute("/_app/getting-started/")({ component: GettingStartedPage });
